define.alias("shared/modifiers/tipalti-iframe-auto-height", "calendar/modifiers/tipalti-iframe-auto-height");